import { DynamicStandaloneTiktok } from '@/components/Tiktok';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorTiktok: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneTiktok
      markup={data.oembed.html}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorTiktok;
